import { SQLite, SQLiteObject } from '@awesome-cordova-plugins/sqlite'
import { isPlatform } from '@ionic/react';
import { SQLiteTableMigrations, SQLiteDataMigrations, CurrentSQLiteDbVersion } from './SQLiteDbMigrations';

  const initSQLiteDB: () =>  Promise<undefined | SQLiteObject> = async() => {
    return await SQLite.create(isPlatform('ios') ? 
      {
        name: 'bst.db',
        iosDatabaseLocation: 'Documents'
      } : 
      {
        name: 'bst.db',
        location: 'default'
      }
    ).then(async(db: SQLiteObject) => {
      const userDbVersion = await getDbVersion(db);
      console.log("User Version: " + userDbVersion, "Current version: " + CurrentSQLiteDbVersion);
      await migrateTables(db, CurrentSQLiteDbVersion, userDbVersion);
      return db; 
    }).catch(error => {
      console.error('ERROR: SQLite DB Init - ', error);
      return undefined;
    })
  }

  const getDbVersion: (db: SQLiteObject) => Promise<number> = async (db) => {
    return db.executeSql("SELECT * FROM version", []).then(result => {
      return result.rows.item(0).number as number;
    })
    .catch(async error => {
      console.error('Failed to DB version', error);
      return 0;
    });
  }

  const migrateTables = async (db: SQLiteObject, dbVersion: number, userDbVersion: number) => {
    // Loop through each table's set of migration
    for (let i:any = 1 + userDbVersion; i <= dbVersion; i++) {
      console.log(`Migrating from db version ${i-1} to ${i}`);
      const dataMigration = SQLiteDataMigrations[i] ? SQLiteDataMigrations[i](db) : false;

      // if there is a data migration for this db version run the pre-migration script
      if(dataMigration) {
        console.log('Running Pre-Data-Migration Script...');
        await dataMigration.preTableMigration();
      }

      // if there is a table migration for the db version run the SQL scripts
      if(SQLiteTableMigrations[i]?.length) {
        await db.sqlBatch(SQLiteTableMigrations[i]).then((result)=> {
          console.log("Successfully Migrated:", SQLiteTableMigrations[i]);
        } )
        .catch(async error => {
          console.error('Failed to Migrate-', error, SQLiteTableMigrations[i]);
        });
      }

      // if there is a data migration for this db version run the post-migration script
      if(dataMigration) {
        console.log('Running Post-Data-Migration Script...');
        await dataMigration.postTableMigration();
      }

    }
  }

export default initSQLiteDB;